import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styles from '../../lib/global.css'
import Page from '../../components/page/page'
import bindAll from 'lodash.bindall'
import { joinClazz, clazzAddCourse, deleteClazz, getClazz, saveClazz, getClazzMembers, clazzShare, quitClazz } from '../../api/clazz';
import { joinedClazzes, getUser } from '../../api/user'
import { setClazz, setCourses, teachInitialState } from '../../reducers/teach'
import Card from '../../components/card/card'
import message from '../../components/message/message'
import BannerInfo from '../../components/banner-info/classs-banner';
import ExitClass from '../../components/modal/exit-modal';
import ButtonComponent from '../../../components/button/button'
import { showLoading } from '../../components/loading/loading'
import qs from 'qs'
import Project from '../../components/project-list/project-transform'
import ApplyClassModal from './apply-clazz-modal';
import UserList from "../../components/user-list/user-list-tranform";
// import UserList from '../../components/user-list/user-list-two'
import ModalManager from '../../components/modal/modal-manager'
import style from './clazz.css';
import Pagination from 'rc-pagination';

/**
 * 课程详情页
 */
class MyClazzPage extends PureComponent {
    constructor(props) {
        super(props)
        bindAll(this, [
            'getClazz',
            'saveClazz',
            'handleJoinClass',
            'deleteCurrentClazz',
            'isJoinedCurrentClass',
            // 'addCourse',
            'getClazzMembers',
            'interceptCourse',
            'onPageChange',
            'getClazzShare',
            'sharePageChange',
            'exitClass'
        ])
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        this.state = { isJoined: false, classMembers: [], current: 1, pageSize: 9, listData: [], shareList: [], shareCurrent: 1, total: null, teacher: null }
        if (props.clazz.id != this.query.id) {
            props.setClazz(teachInitialState.clazz)
        }
    }
    componentDidMount() {
        this.isJoinedCurrentClass();
        this.getClazzMembers();
        this.getClazz();
        this.getClazzShare();
    }
    getClazz() {
        showLoading()
        getClazz({ id: this.query.id }, { quiet: !!this.props.clazz.id }).then(res => {
            this.props.setClazz(res)
        }).then(() => {
            this.interceptCourse();
            const { clazz } = this.props;
            getUser({ id: clazz.user_id }, { quiet: !!this.props.username }).then(res => {
                this.setState({
                    teacher: res.name
                })
            })
        })
    }

    async getClazzMembers() {
        getClazzMembers({ id: this.query.id, page_size: 100 }).then(res => {
            if (res && res.data) {
                this.setState({ classMembers: res.data });
            }
        });

    }

    saveClazz(clazz) {
        saveClazz(clazz).then(() => {
            message.show(window.L('teach.class.saveSuccess'))
        })
    }
    deleteCurrentClazz() {
        if (confirm(window.L('teach.class.deleteConfirm'))) {
            deleteClazz({ id: this.props.clazz.id }).then(() => {
                message.show(window.L('teach.common.deleteSuccess'))
                this.props.history.go(-1)
            })
        }
    }
    // 加入班级
    async handleJoinClass() {
        ModalManager.open(ApplyClassModal, {
            onClose: () => { },
            onApply: async (v) => {
                if (v) {
                    const res = await joinClazz({ clazz_code: v })
                    if (res) {
                        ModalManager.pop()
                        this.setState({ isJoined: true }, () => {
                            this.getClazzMembers();
                        })
                    }
                }
            }
        })
    }
    async isJoinedCurrentClass() {
        const res = await joinedClazzes()
        if (res) {
            const inClass = res.some(item => String(item.id) === this.query.id)
            this.setState({ isJoined: inClass }, () => {
                if (this.query.type && this.query.type == 1 && !inClass) {
                    this.handleJoinClass()
                }
            })
        }
    }

    // 退出班级
    async exitClass() {
        ModalManager.open(ExitClass, {
            onClose: () => { },
            onSubmit: async () => {
                const res = await quitClazz({ id: this.query.id })
                if (res) {
                    ModalManager.pop()
                    this.setState({ isJoined: false }, () => {
                        this.getClazzMembers();
                    })
                }
            },
            title: '退出班级'
        })
    }
    // addCourse(course) {
    //     clazzAddCourse({
    //         id: this.props.clazz.id,
    //         course_id: course.extensionId
    //     }).then(res => {
    //         message.show(res)
    //         this.getClazz()
    //     })
    // }

    //获取分享作品
    getClazzShare() {
        const { shareCurrent, pageSize } = this.state
        clazzShare({ clazz_id: this.query.id, page_size: pageSize, page: shareCurrent }, { quiet: !!this.props.clazz.id }).then(res => {
            this.setState({
                shareList: res.data,
                total: res.total
            })
        })
    }

    // 分享作品分页
    sharePageChange(page) {
        this.setState({
            shareCurrent: page
        }, () => {
            this.getClazzShare()
        })
    }

    // 分页截取课程
    interceptCourse() {
        const { clazz } = this.props;
        const { current, pageSize } = this.state;
        if (clazz && clazz.courses.length > 0) {
            this.setState({
                listData: clazz.courses.slice((current - 1) * pageSize, (current * pageSize))
            })
        } else {
            this.setState({
                listData: []
            })
        }
    }

    //分页
    onPageChange(page) {
        this.setState({
            current: page
        }, () => {
            this.interceptCourse()
        })
    };


    render() {
        if (this.props.clazz.id != this.query.id) {
            return null;
        }
        const { clazz } = this.props;
        const { pageSize, current, listData, shareList, total, shareCurrent, isJoined, teacher } = this.state;
        return (
            <Page isModal={true} title={clazz.name}>
                {clazz.id &&
                    <React.Fragment>
                        <BannerInfo
                            // title={clazz.name || ''}
                            // cover={clazz.cover || `${window.config.staticURL}/cover/class/default.png`}
                            // desc={clazz.school ? (clazz.school.name || '') : (clazz.school_name || '')}
                            teacher={teacher}
                            classInfo={clazz}
                            buttons={
                                <React.Fragment>
                                    <ButtonComponent
                                        disabled={isJoined}
                                        className={
                                            isJoined ? `${styles.button} ${styles.disable}` : styles.button
                                        }
                                        onClick={this.handleJoinClass}
                                    >{isJoined ? '已加入' : '加入班级'}</ButtonComponent>
                                </React.Fragment>
                            }
                            isJoined={isJoined}
                            onExit={this.exitClass}
                        />
                        <div className={style.courseBox}>
                            <div className={style.leftCourse}>
                                <Card
                                    title={window.L('teach.class.courses')}
                                    style='white'
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <Project
                                            data={listData}
                                            cardType='course'
                                            itemNum={4}
                                        />
                                        <Pagination
                                            current={current}
                                            defaultPageSize={pageSize}
                                            total={clazz.courses.length}
                                            onChange={this.onPageChange}
                                        ></Pagination>
                                    </div>
                                </Card>
                                <Card
                                    title={window.L('teach.class.shareProject')}
                                    style='white'
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <Project
                                            data={shareList}
                                            itemNum={4}
                                            userShow={true}
                                            share={true}
                                        />
                                        <Pagination
                                            current={shareCurrent}
                                            defaultPageSize={pageSize}
                                            total={total}
                                            onChange={this.sharePageChange}
                                        ></Pagination>
                                    </div>
                                </Card>
                            </div>
                            <div className={style.rightRank}>
                                <UserList
                                    title={window.L('teach.class.members')}
                                    users={this.state.classMembers}
                                    onItemSelected={() => { }}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                }
            </Page>
        )
    }
}

const mapStateToProps = state => ({
    clazz: state.teach.clazz,
    courses: state.teach.courses
})


const mapDispatchToProps = dispatch => ({
    setClazz: res => dispatch(setClazz(res)),
    setCourses: courses => dispatch(setCourses(courses))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MyClazzPage))
